import { h } from "preact";

import i18n from "../../i18n";
import Button from "../Button.jsx";

export default {
  bank_account_start: ({ onNext }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">Bank account finder</h1>
        <p class="task-page__content">
          Pick the right German bank account for your needs.
        </p>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.start")}</Button>
        </div>
      </section>
    );
  },
  bank_account_test: ({ chooser, product, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">{product.name}</h1>
        <p class="task-page__content">TODO</p>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{chooser ? "Choose" : "Ok"}</Button>
          {!chooser && (
            <Button text onClick={onRestart}>
              {i18n.t("actions.discard_result")}
            </Button>
          )}
        </div>
      </section>
    );
  },

  bank_account_test2: ({ chooser, product, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">{product.name}</h1>
        <p class="task-page__content">TODO</p>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{chooser ? "Choose" : "Ok"}</Button>
          {!chooser && (
            <Button text onClick={onRestart}>
              {i18n.t("actions.discard_result")}
            </Button>
          )}
        </div>
      </section>
    );
  },
};
